import React from 'react';
import { getCustomerColumnWidth } from '../../adapter/utils';
import { getSysFieldid } from '@platform/api';

function useIndex(Table) {
    return class IndexTable extends React.Component{
        render(){
            let { indexConfig = { enable: false }, columns = [], locale } = this.props;
            if(indexConfig.enable && columns.length){
                columns = [{
                    title: <div 
                        className='table-next-header-title'
                        fieldid={getSysFieldid('numberindex')}
                    >
                        {locale['table001'] /*'序号'*/}
                    </div>,
                    key: 'INDEX',
                    width: indexConfig.width ?? 60,
                    isLeaf: true,
                    depth: 0,
                    fixed: 'left',
                    resizable: true,
                    render: (row, index) => {
                        return <div className='table-cell'>{index + 1}</div>;
                    },
                }, ...columns];
            }
            return (
                <Table {...this.props} columns={columns}/>
            );
        }
    };
}

useIndex.displayName = 'useIndex';
useIndex.dependence = [];
useIndex.propsGenerator = function(props){
    const { indexConfig } = props;

    if(!indexConfig?.enable) return props;

    const { store, id } = props;

    return {
        ...props,
        indexConfig: {
            ...indexConfig,
            width: getCustomerColumnWidth(store, id, 'INDEX', 60),
        },
    };
};

export default useIndex;